<div>

    <div class="containerShipment accordion" id="accordionExample">

        <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button titleShipment" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    <i class="icon-filters"></i> <span *ngIf="filtersActive"
                    class="translate-middle  bg-danger rounded-circle"></span>
                    {{ 'guarantee.titleFilters' | translate }}
                </button>
            </h2>

            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    <form [formGroup]="formFilters" class="row g-4" style="padding: 1.5rem;">

                        <div class="col-4 inputDate">
                            <input type="text" class="form-control" placeholder="Ref GRN NO." formControlName="refNo">
                         
                        </div>
                        <div class="col-4 inputDate">
                              <input type="text" class="form-control"  placeholder=" {{ 'guarantee.dateInput' | translate }}" formControlName="dateFilter" readonly>
                         <!--    <div class="col-3  input-group">
                                <input class="form-control datepicker" placeholder="Select a date" angular-mydatepicker
                                    name="dateFilter" formControlName="dateFilter" [options]="myDatePickerOptions"
                                    (click)="dp.toggleCalendar()" #dp="angular-mydatepicker" />
                                <span class="input-group-btn">
                                    <button type="button" class="btn btn-calendar" (click)="dp.clearDate()"><i
                                            class="icon-cross"></i></button>
                                    <button type="button" class="btn btn-calendar2" (click)="dp.toggleCalendar()"><i
                                            class="icon-calendar"></i></button>
                                </span>

                            </div> -->
                        </div>
                        <div class="col-4">
                            <input type="text" class="form-control" placeholder=" {{ 'guarantee.ammount' | translate }}" formControlName="ammount" readonly>
                        </div>

                        <div class="col-12 colButtonsForm float-end">
                            <hr>
                            <button class="btn btn-secondary btnReset" type="reset" (click)="resetFilters()"> {{ 'guarantee.reset' | translate }}</button>
                            <button class="btn btn-primary btnApply" [disabled]="!formFilters.valid"
                                (click)="search()">{{ 'guarantee.apply_filters' | translate }}</button>
                        </div>

                    </form>
                </div>
            </div>
        </div>

    </div>
    <div class="containerDataTable">
 <!--        <img  class="imgDataTable" src="assets/images/guarantee.svg" alt=""> -->
       <!--  <h2 *ngIf="filtersActive" class="titleTable">GUARANTEE DATA</h2> -->
       <!--  <table *ngIf="filtersActive" datatable [dtOptions]="dtOptions" class="row-border hover">
            <thead>
                <tr class="tableHeader">
                    <th></th>
                    <th>Shipment Number</th>
                    <th>Date of arrival</th>
                    <th>Control ENS</th>
                    <th>CACESA----ialb</th>
                    <th>Conex</th>
                    <th>ARN-conex</th>
                    <th>Huzard</th>
                    <th> CN Code</th>
                    <th>Goods description EN</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let person of data">
                    <td></td>
                    <td>{{ person.number }}</td>
                    <td>{{ person.date }}</td>
                    <td><span class="pill pill-warning">Primary</span></td>
                    <td>{{ person.cacesa }}</td>
                    <td>{{ person.conex }}</td>
                    <td>{{ person.arn }}</td>
                    <td>{{ person.huzard }}</td>
                    <td>{{ person.cn_code }}</td>
                    <td>{{ person.description }}</td>
                    <td class="text-center">
                        <button class="btn btnEdit"><i class="icon-edit"></i></button>
                    </td>
                </tr>
            </tbody>
        </table> -->
    </div>
</div>